import { valueOf } from "@/types/common";

export const RSO_LIST_TAB = {
  DURING_CONTRACT: "DURING_CONTRACT",
  CANCELED_CONTRACT: "CANCELED_CONTRACT",
  TRIAL: "TRIAL",
  TRIAL_CANCELLED: "TRIAL_CANCELLED",
};

export type TRsoListTab = valueOf<typeof RSO_LIST_TAB>;

export const RSO_LIST_TAB_LABEL = {
  [RSO_LIST_TAB.DURING_CONTRACT]: "契約中の機関一覧",
  [RSO_LIST_TAB.CANCELED_CONTRACT]: "解約済みの機関一覧",
  [RSO_LIST_TAB.TRIAL]: "トライアル中の機関一覧",
  [RSO_LIST_TAB.TRIAL_CANCELLED]: "トライアル終了の機関一覧",
};
